import { Link } from 'react-router';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Button } from 'Components/LegacyButton';
import { Typography } from 'Components/Typography';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import type { textDataType } from './type';

const Wrapper = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  padding: 0px ${theme.spacing['4x']};
  margin-bottom: ${theme.spacing['8x']};
  ${legacyTheme.breakpoints.up('sm')} {
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
  }
  ${legacyTheme.breakpoints.up('md')} {
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
  }
`;
const StyledTypography = styled(Typography)`
  ${legacyTheme.breakpoints.up('sm')} {
    margin-bottom: ${theme.spacing['6x']};
  }
`;

type TextTitleBlockProps = {
  textData: textDataType;
};

export const TextTitleBlock = ({ textData }: TextTitleBlockProps) => {
  const { isMobile } = useResponsiveVariant();
  const { sectionTitle, cta } = textData;
  const ctaLabel = isMobile ? cta.labelMobile : cta.labelDesktop;
  const category = cta.labelMobile.includes('skin') ? 'skincare' : 'haircare';
  return (
    <Wrapper>
      <StyledTypography variant="h2">{sectionTitle}</StyledTypography>
      <Button
        Component={Link}
        data-click={`explore-${category}`}
        data-from={`${category}-grid`}
        to={cta.path}
        variant="underlinedBlackMono"
      >
        {ctaLabel}
      </Button>
    </Wrapper>
  );
};
